/* eslint-disable react/no-unknown-property */
import React from 'react'

const Video = ({
  autoplay = '1',
  className,
  videoID,
  videoTitle = '',
  withIcon,
  ...props
}) => {
  return (
    <div className={className} id="video">
      <iframe
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        autoPlay={autoplay}
        className={className}
        enablejsapi="1"
        frameBorder="0"
        height="500"
        id="videoframe"
        loading="lazy"
        marginHeight="0"
        marginWidth="0"
        scrolling="no"
        src={`https://www.youtube.com/embed/${videoID}?rel=0&amp;&autoplay=${autoplay}&enablejsapi=1&widgetid=1&controls=0&showinfo=0`}
        title={videoTitle}
        type="text/html"
        width="800"
        {...props}
      />
    </div>
  )
}

export default Video
